import { usePageProductsContext } from '@app/components/pages/context/PageProductsContext';
import { CmsProduct } from '@app/components/products/CmsProduct/CmsProduct';
import { getScreenRelativeStyles } from '@app/logic/pages';
import { useIsInViewMode, useSpecifiedDeviceWidth } from '@app/utils/hooks';
import { isDefined } from '@app/utils/is';
import { Cms, CmsBlocks } from '@typings';

export const ProductBlock = (props: CmsBlocks.BlockProps<Cms.ProductBlock>) => {
  const { parameters, rowHeight } = props;
  const { position, settings } = parameters;
  const { products: productsList } = settings;
  const isInPreview = useIsInViewMode('preview');
  const screenWidth = useSpecifiedDeviceWidth();
  const { products, getProductUrl, isLookbook } = usePageProductsContext();
  const screenRelativePosition = getScreenRelativeStyles(screenWidth, position);

  return (
    <>
      <div
        className="grid content-start gap-8"
        style={{
          gridTemplateColumns: `repeat(${screenRelativePosition.spanX}, minmax(0, 1fr))`,
          height: 'auto',
        }}
      >
        {productsList.map(product => {
          const productData = products[product];

          if (!isDefined(productData)) {
            return null;
          }

          return (
            <CmsProduct
              key={product}
              isInPreview={isInPreview}
              style={{ height: rowHeight }}
              productInfo={productData}
              getProductUrl={getProductUrl}
              hideButtons={isLookbook}
            />
          );
        })}
      </div>
    </>
  );
};
